import React, {useContext} from "react";
import HeaderPage from "../components/HeaderPage";
import {View} from "react-native";
import Button from "../components/Button";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {Colors} from "../colors";
import {ColumnSpace} from "../components/_CommonComponents";
import Text from "../components/Text";
import Map from "../../../components/custom-components/Map";
import {AppFunctionsContext} from "../../../contexts/AppFunctionsContext";
import DeliveryAddressList from "../../../components/data-components/DeliveryAddressList";
import { border } from "native-base/lib/typescript/theme/styled-system";

export default function Delivery({route, navigation}: any) {
    const configContext = useContext(AppConfigContext);
    const colors = Colors.instanceNoServerColor(configContext.theme, configContext.color);
    const appFunctions = useContext(AppFunctionsContext);

    let {selectable}: { selectable: boolean } = route.params ?? {selectable: true};

    const personalDelivery = () => {
        appFunctions.appNavigator.toOverviewFromDelivery(null);
    }

    return <HeaderPage title={"انتخاب آدرس"} scrollableContent={true}>
        <DeliveryAddressList navigationParams={route.params} renderItem={(da, selectable) => {
            const address = da.item;
            return <View style={{
                flexDirection: "row",
                flex: 1,
                paddingHorizontal:8,
                borderRadius:15,
                backgroundColor: colors.get("cardBg") as string,
                margin:8,
                shadowOpacity: 0.1, 
                shadowRadius:4,
                shadowOffset:{height: 3,width: 3}
            }}>
                <View style={{flex: 2, padding: 10, justifyContent: "space-evenly"}}>
                    <View style={{flexDirection: "row", paddingVertical: 2}}>
                        <Text size={14} color={colors.get("highConText") as string} weight={300}>عنوان
                            آدرس: </Text>
                        <Text size={14} color={colors.get("highConText") as string}
                              weight={500}>{address.title}</Text>
                    </View>
                    <View style={{flexDirection: "row", paddingVertical: 2}}>
                        <Text size={14} color={colors.get("highConText") as string} weight={300}>تحویل
                            گیرنده: </Text>
                        <Text size={14} color={colors.get("highConText") as string}
                              weight={500}>{address.clientName}</Text>
                    </View>
                    <View style={{flexDirection: "row", paddingVertical: 2}}>
                        <Text size={14} color={colors.get("highConText") as string} weight={300}>آدرس: </Text>
                        <Text size={14} numberOfLines={2} ellipsizeMode={"head"}
                              color={colors.get("highConText") as string}
                              weight={500}>{address.address}</Text>
                    </View>
                    <View style={{flexDirection: "row", justifyContent: "space-between", paddingTop: 10}}>
                        <View style={{flexDirection: "row"}}>
                            {selectable ?
                                <Button paddingType="narrow" title={"انتخاب"} scheme={"solid"}
                                        onPress={() => appFunctions.appNavigator.toOverviewFromDelivery(address)}/> : <></>}
                        </View>
                        <Button paddingType="narrow" title={"ویرایش"} scheme={"regular"}
                                onPress={() => appFunctions.appNavigator.toAddressEdit(address)}/>
                    </View>
                </View>
                <View style={{flex: 1,justifyContent:"center",borderTopLeftRadius:15,borderBottomLeftRadius:15, backgroundColor:colors.get("cardBg") as string, margin:8,marginRight:0,marginLeft:0}}>

                    <Map function={"overview"} borderRadius={15} width={"100%"} height={"100%"}
                         defaultLocation={{
                             lat: address.latlong.lat,
                             long: address.latlong.long
                         }}/>

                </View>
            </View>
        }}/>

        {/*Todo: Add a hint for user to know he has to add a address for delivery*/}
        <View style={{padding: 8}}>
            <View style={{borderColor:colors.get("primaryColor") as string,borderWidth:1,borderRadius:15}}>
            <Button title={"افزودن آدرس جدید"}
                    color={colors.get("primaryColor") as string}
                    onPress={appFunctions.appNavigator.toAddAddress}
                    scheme={"regular"}/>
            </View>
            <ColumnSpace h={8}/>
            {selectable ?
                <Button title={"دریافت به صورت حضوری از رستوران"}
                        color={colors.get("primaryColor") as string}
                        onPress={personalDelivery}/> : <></>}
        </View>
    </HeaderPage>
}
